
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/review-widget/[token]",
      function () {
        return require("private-next-pages/review-widget/[token].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/review-widget/[token]"])
      });
    }
  